<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="10">
        <v-row>
          <div class="body-1 primaryText--text text-left">
            <p>Upload a copy of the front and picture page of your passport.</p>
            <div class="mt-8">
              <strong>Owning a passport valid for international travel is a non-negotiable requierment for those who will be selected for the Italian residential module. Please check well in advance with your local authorities how to obtain a valid visa to travel to Italy.</strong>
            </div>
          </div>
        </v-row>
        <v-row class="mt-8">
          <v-file-input
            v-if="!passportFileId"
            accept="application/pdf, image/*"
            prepend-icon="mdi-file-upload-outline"
            :loading="uploadingFile"
            @change="onFileChanged($event,'passportFileId','passport')"
            :error-messages="passportRequiredErrors"
          />
          <v-text-field
            v-else
            clear-icon="mdi-trash-can-outline"
            append-outer-icon="mdi-open-in-new"
            @click:append-outer="onFileOpen('passport')"
            @click:clear="onFileCleared('passportFileId','passport')"
            :value="passport.originalName"
            readonly
            clearable
          />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import submissionMixin from "../mixins/submission.mixin";
import { mapFields } from "vuex-map-fields";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Passport",
  mixins: [submissionMixin],
  computed: {
    ...mapFields("profile", {
      passportFileId: "profile.passportFileId",
      passport: "profile.passport"
    }),
    passportRequiredErrors(){
      const errors = [];
      if (!this.$v.passportFileId.$dirty) return errors;
      !this.$v.passportFileId.required &&
        errors.push("A copy of your passport is required");
      return errors;        
    }
  },
  validations: {
    passportFileId: {
      required
    }
  }
};
</script>